import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TextFieldData from "./TextFiledData"; // Fixed import name
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import { put, get } from "../../../utils/api";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const Economic218 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [fromData, setFromData] = useState({
    devlopmentTopics: "",
    independentEvaluationBody: "",
    actionsTakenInResponseToEvaluations: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  // Function to validate the form fields
  const validateFields = () => {
    const newErrors = {};

    // Loop through the 'fromData' object and validate
    Object.keys(fromData).forEach((sectionKey) => {
      const section = fromData[sectionKey];

      // If section is an object, loop through the fields inside it
      if (typeof section === "object") {
        Object.keys(section).forEach((fieldKey) => {
          if (!section[fieldKey]) {
            // If the field is empty, mark it as an error
            if (!newErrors[sectionKey]) {
              newErrors[sectionKey] = {};
            }
            newErrors[`${sectionKey}.${fieldKey}`] = `This field is required`;
          }
        });
      } else if (!section) {
        // If section is not an object, just check the value
        newErrors[sectionKey] = `This field is required`;
      }
    });
    console.log(newErrors);
    setErrors(newErrors);
    return newErrors;
  };

  const fetchData = async () => {
    await get(`/gri/get?type=GeneralDisclosures2021&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false)
          setDisabled(true);
        setFromData({
          devlopmentTopics:
            res.data.data.GeneralDisclosures2021.performanceEvaluationProcess
              .devlopmentTopics,
          independentEvaluationBody:
            res.data.data.GeneralDisclosures2021.performanceEvaluationProcess
              .independentEvaluationBody,
          actionsTakenInResponseToEvaluations:
            res.data.data.GeneralDisclosures2021.performanceEvaluationProcess
              .actionsTakenInResponseToEvaluations,
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Function to handle form submission
  const handleSubmit = async () => {
    // const validationErrors = validateFields();

    // If there are errors, prevent form submission
    // if (Object.keys(validationErrors).length > 0) {
    //   console.log("Form contains errors", fromData, validationErrors);
    //   return;
    // }
    if (!disabled) {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, {
          type: "GeneralDisclosures2021",
          performanceEvaluationProcess: { ...fromData },
          submitted2_18: true,
        });
        navigate(`/gri/general-disclosure/2-19/${id}`);
      } catch {
        console.log(errors);
      }
    } else {
      navigate(`/gri/general-disclosure/2-19/${id}`);
    }
  };

  const inputData = [
    {
      index: "a.",
      heading:
        "Describe the specific measures taken by the organization to advance the collective knowledge, skills, and experience of the highest governance body on sustainable development topics.",
      fieldName: "devlopmentTopics",
    },
    {
      index: "b.",
      heading:
        "Describe whether the evaluations of the highest governance body's performance conducted by an independent body or process. If not independent, how is objectivity ensured during the evaluation. And report how often these evaluations are conducted (annually/ biannually) etc.",
      fieldName: "independentEvaluationBody",
    },
    {
      index: "c.",
      heading:
        "Describe actions taken in response to the evaluations, including changes to the composition of the highest governance body and organizational practices.",
      fieldName: "actionsTakenInResponseToEvaluations",
    },
  ];

  const renderContent = ({ hide }) => (
    <>
      <TextFieldData
        title="2-18 Evaluation of the performance of the highest governance body"
        {...{
          inputData,
          fromData,
          setFromData,
          setErrors,
          disabled: disabled,
          errors,
          hide
        }}
      />
    </>
  );
  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default Economic218;
